import { GdsMeritTags, BldMeritTags, AgntMeritTags } from '@remodeling/goods';

export const getGdsEmoji = (code?: GdsMeritTags): string => {
  switch (code) {
    case 'LUXURY_DESIGN':
      return '✨';
    case 'VARIOUS_PRODUCTS_SELECTION':
      return '🛍️';
    case 'ECO_FRIENDLY_MATERIALS':
      return '🌿';
    case 'REASONABLE_PRICE_QUALITY':
      return '💰';
    case 'IN_STORE_PRODUCT_VIEWING':
      return '👀';
    default:
      return '';
  }
};

export const getBldEmoji = (code?: BldMeritTags): string => {
  switch (code) {
    case 'PROFESSIONAL_INSTALLATION':
      return '👍';
    case 'ATTENTION_TO_DETAIL':
      return '🧐';
    case 'FLEXIBLE_SCHEDULING':
      return '🗓️';
    case 'CLEAN_FINISH':
      return '🧹';
    case 'AFTER_SALE_SUPPORT':
      return '🧰';
    default:
      return '';
  }
};

export const getAgntEmoji = (code?: AgntMeritTags): string => {
  switch (code) {
    case 'PROFESSIONAL':
      return '👨‍💻';
    case 'RESOLVING':
      return '🤓';
    case 'PREVIEW':
      return '👀';
    case 'CUSTOMIZED':
      return '✏️';
    case 'TRUSTWORTHY':
      return '😌';
    default:
      return '';
  }
};
